import React from 'react';

const Hero = () => {
  return (
    <section className="py-20 overflow-hidden">
      <div className="container mx-auto px-6 relative">
        <div className="absolute inset-0 opacity-10 transform rotate-12 skew-x-12"></div>
        <div className="relative z-10 text-center">
          <h1 className="text-5xl md:text-7xl font-bold mb-4 animate-fade-in-down text-white">Suprith S</h1>
          <p className="text-xl md:text-2xl mb-8 animate-fade-in-up">Computer Science & Engineering Student | Data Science Diploma Graduate</p>
          <div className="flex justify-center space-x-4">
            <a href="mailto:supriths4804@gmail.com" className="bg-red-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-red-700 transition duration-300 transform hover:scale-105">Email</a>
            <a href="https://linkedin.com/in/suprith-s44" target="_blank" rel="noopener noreferrer" className="bg-blue-700 text-white px-6 py-3 rounded-full font-semibold hover:bg-blue-800 transition duration-300 transform hover:scale-105">LinkedIn</a>
            <a href="https://github.com/Suprith-44" target="_blank" rel="noopener noreferrer" className="bg-gray-800 text-white px-6 py-3 rounded-full font-semibold hover:bg-gray-900 transition duration-300 transform hover:scale-105">Github</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;